module.exports = __webpack_public_path__ + "img/loading_cover_word.ea791492.png";